const historyItemTranslations = {
  actions: {
    activity: {
      created: "Aktivität angelegt",
      done: "Aktivität erledigt",
      deleted: "Aktivität gelöscht",
      unknown: "Aktivität geändert",
    },
    beaMessage: {
      sent: "beA gesendet",
      received: "beA empfangen",
      unknown: "beA-Nachricht",
    },
    emailMessage: {
      sent: "E-Mail gesendet",
      received: "E-Mail erhalten",
    },
    fax: "Fax gesendet",
    inquiryToCustomer: "Anfrage gestellt",
    mediaObject: "Datei hinzugefügt",
    mediaObjectDelete: "Datei entfernt",
    mediaObjectIdentifierChange: "Datei geändert",
    message: {
      sent: "Nachricht gesendet",
      received: "Nachricht erhalten",
    },
    note: "Notiz hinzugefügt",
    paidTask: "Ausschreibung erstellt",
  },
  details: {
    deletedDocument: "Dokument gelöscht",
    unavailable: "Details nicht verfügbar",
    loading: "Details werden geladen",
    emptySummary: "Keine Zusammenfassung verfügbar",
  },
  emailMessage: {
    label: "Emails",
  },
  lawyer: {
    label: "Anwalt",
  },
  fax: {
    label: "Faxe",
  },
  accountManager: {
    label: "Zuständiger",
  },
  assignedUserChange: {
    label: "Zuständigkeit geändert",
  },
  beaMessage: {
    label: "beA Nachrichten",
  },
  paidTask: {
    label: "Ausschreibungen",
  },
  passwordReset: {
    label: "Passwort zurückgesetzt",
  },
  mailPause: {
    label: "Emails und Nachrichten pausiert",
  },
  activity: {
    label: "Aktivitäten",
  },
  note: {
    label: "Notizen",
  },
  mediaObject: {
    label: "Dokumente",
  },
  mediaObjectDelete: {
    label: "Verlaufseintrag für gelöschte Datei",
  },
  customerRegistration: {
    label: "Registrierung",
  },
  caseCreated: {
    label: "Fall erstellt",
  },
  entityStatusChange: {
    label: "Status geändert",
  },
  entityStatusChangeByCustomerPrevented: {
    label: "Statusänderung verhindert",
  },
  entityDataChange: {
    label: "Daten geändert",
  },
  customerDataChange: {
    label: "Daten geändert",
  },
  caseStatusChange: {
    label: "Zustand geändert",
    lost: {
      label: "Fall verloren",
      lostCategory: {
        noResponse: "Kein Kontakt möglich / Keine Rückmeldung",
        caseChange: "Wechsel auf anderen Fall",
        customerRefusal: "Ablehnung weiteres Vorgehen durch Kunde (ohne Begründung)",
        insuranceRefusal: "Kostenablehnung durch RSV",
        noInsurance: "Schlechtes Kosten-Nutzen-Verhältnis (z.B. durch fehlende RSV)",
        noLegalBasis: "Rechtliches Vorgehen nicht möglich / Kein Case",
        localLawyer: "Lokaler Anwalt",
        nonPayment: "Verloren wegen Nichtzahlung",
        noCorrespondingProduct: "Kein Legalbird-Rechtsgebiet",
        other: "Sonstiges",
      },
    },
    won: {
      label: "Fall gewonnen",
    },
    open: {
      label: "Fall wieder geöffnet",
    },
    inactive: {
      label: "Fall inaktiv",
    },
  },
  invoiceTypeIdentifierChange: {
    label: "Rechnung geändert",
  },
  invoiceDelete: {
    label: "Rechnung gelöscht",
  },
  invoiceReassign: {
    label: "Rechnung umgehängt",
  },
  client: "Mandantschaft",
  inquiry: {
    label: "Inquiry",
    status: {
      open: "Offen",
      inProgress: "In Bearbeitung",
      overdue: "Überfällig",
      done: "Erledigt",
    },
    type: {
      documents: "Dokumente",
      appointment: "Termin",
      information: "Informationen",
      informationAndDocuments: "Informationen und Dokumente",
      decision: "Entscheidung",
    },
    link: {
      identifier: {
        label: "Identifier",
        unknown: {
          label: "Anfrage mit verlinkter Seite",
        },
        nextInstanceDecisionInquiry: {
          label: "Anfrage Entscheidung Berufungsverfahren",
        },
        customerFeedbackInquiry: {
          label: "Anfrage weiteres Vorgehen",
        },
        administrativeDecisionFeedbackInquiry: {
          label: "Anfrage weiteres Vorgehen Bescheid",
        },
        dataLeakPersonalInvolvementInquiry: {
          label: "Anfrage persönliche Betroffenheit",
        },
        customerUpdatePoAInquiry: {
          label: "Anfrage neue Vollmacht",
        },
      },
    },
    decision: {
      label: "Entscheidung",
      question: {
        label: "Frage",
      },
      answer: {
        label: "Antwort",
        yes: {
          label: "Ja",
        },
        no: {
          label: "Nein",
        },
      },
    },
  },
};

export default historyItemTranslations;
